import { combineReducers } from 'redux';
// import { connectRouter } from 'connected-react-router'
import users from "@components/users/reducer";
import layout from "@components/layout/reducer";
import categories from "@components/categories/reducer";
import suppliers from "@components/suppliers/reducer";
import characteristicGroups from "@components/characteristic-groups/reducer";
import characteristics from "@components/characteristics/reducer";
import products from "@components/product/reducer";
import orders from "@components/orders/reducer";
import modules from "@components/module-management/reducer";
import invoice from "@components/invoice/reducer";
import chat from '@components/chat/reducer'
import context from "./context";

const rootReducer = (history) => combineReducers({
    // router: connectRouter(history),
    router: history,
    users,
    layout,
    context,
    categories,
    suppliers,
    characteristicGroups,
    characteristics,
    products,
    orders,
    modules,
    invoice,
    chat,
});

export default rootReducer;
